import React, { useState, useEffect } from 'react';
import './ServiceCards.scss';

import notesIcon from '../../Assets/images/notes.png';
import smallTruckIcon from '../../Assets/images/small_truck.png';

const cardData = [
  {
    id: 'cc',
    signupType: 'cc',
    icon: notesIcon,
    iconAlt: 'Contractors icon',
    title: 'For Contractors (CC)',
    features: [
      'Full Compliance (WSIB + Insurance)',
      'Real-Time Fleet View',
      'Net-30 Invoicing',
    ],
    ctaLabel: 'CONSTRUCTION COMPANY / SIGN UP',
    ctaVariant: 'filled',
    delay: '0ms',
  },
  {
    id: 'tc',
    signupType: 'tc',
    icon: smallTruckIcon,
    iconAlt: 'Carriers icon',
    title: 'For Carriers (TC)',
    features: [
      'Keep 95% of Every Load',
      'GTA Network Access',
      'Automated Net-30 Payouts',
    ],
    ctaLabel: 'TRUCK COMPANY / SIGN UP',
    ctaVariant: 'outlined',
    delay: '100ms',
  },
];

const ServiceCards = ({ onSignUpClick }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let lastVisible = false;
    const handleScroll = () => {
      const next = window.scrollY >= window.innerHeight * 0.1;
      if (next !== lastVisible) {
        lastVisible = next;
        setVisible(next);
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="service-cards-section">
      <div className="container">
        <div className="row service-cards-row">
          {cardData.map((card) => (
            <div key={card.id} className="col-md-6">
              <div
                className={`service-card ${visible ? 'visible' : ''}`}
                style={{ '--delay': card.delay }}
              >
                <div className="service-card__header">
                  <img
                    src={card.icon}
                    alt={card.iconAlt}
                    className="service-card__icon"
                  />
                  <h3 className="service-card__title">{card.title}</h3>
                </div>

                <ul className="service-card__features">
                  {card.features.map((feature) => (
                    <li key={feature} className="service-card__feature-item">
                      <span className="service-card__check" aria-hidden="true">✓</span>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                <button
                  type="button"
                  className={`service-card__cta service-card__cta--${card.ctaVariant}`}
                  onClick={() => onSignUpClick(card.signupType)}
                >
                  {card.ctaLabel}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServiceCards;
